<div class="db-cdn-integration">
  <div dbCustomScrollbar>
    <h2 class="mb20" [innerHTML]="'text_verifyCloudflareHostnameHeader' | dbText" *ngIf="!cdnIsLive"></h2>

    <div class="db-verify-domain mb20" *ngIf="!cdnIsLive">
      <p>1. Verify the domain ownership</p>
      <span [innerHTML]="'text_addTxtRecords' | dbText"></span>
      <div class="db-copy-info mt14 mb8">
        <div>
          <div class="db-copy-info__list-header">
              <p>{{ 'text_type' | dbText }}</p>
              <p>{{ 'text_hostName' | dbText }}</p>
              <p>{{ 'text_value' | dbText }}</p>
          </div>
          <div>
            <ul>
              <ng-container *ngFor="let record of dnsRecordsForCopy; let i = index" >
                <li class="db-copy-info__list-item {{record}}" *ngIf="record !== ''">
                  <p>TXT</p>
                  <p>
                    <input type="text" class="form-control host-name" #inputHostName [value]="record.name">
                    <a [ngxClipboard]="inputHostName" (cbOnSuccess)="copiedHostName(i)" (click)="isCopiedHostNames[i] = true"
                       (onTooltipHide)="isCopiedHostNames[i] = false"
                       class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                       dsTooltipColor="black"
                       [dsTooltip]="'<b>' + ((isCopiedHostNames[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                    </a>
                  </p>
                  <p [ngClass]="{'ds-lazy-load': loading}">
                    <input type="text" class="form-control" [(ngModel)]="record.value" #inputNameServer>
                    <a [ngxClipboard]="inputNameServer" (cbOnSuccess)="copiedNameServer(i)" (click)="isCopiedCodes[i] = true"
                       (onTooltipHide)="isCopiedCodes[i] = false"
                       class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                       dsTooltipColor="black"
                       [dsTooltip]="'<b>' + ((isCopiedCodes[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                    </a>
                  </p>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="db-point-domain" *ngIf="cdnIsLive || showVerify">
      <h2 *ngIf="cdnIsLive">Point the domain to Cloudflare</h2>
      <p class="mt12" *ngIf="!cdnIsLive">2. Point the domain to Cloudflare</p>
      <span [innerHTML]="'text_configDns' | dbText"></span>
      <div class="db-copy-info mt14 mb8">
        <div>
          <div class="db-copy-info__list-header">
              <p>{{ 'text_type' | dbText }}</p>
              <p>{{ 'text_hostName' | dbText }}</p>
              <p>{{ 'text_value' | dbText }}</p>
          </div>
          <div>
            <ul>
              <li class="db-copy-info__list-item" *ngFor="let record of cfRecordsForCopy; let i = index">
                <p>A</p>
                <p>
                  <input type="text" class="form-control host-name" #inputAHostName [value]="record.name">
                  <a [ngxClipboard]="inputAHostName" (cbOnSuccess)="copiedAHostName(i)" (click)="isCopiedAHostNames[i] = true"
                     (onTooltipHide)="isCopiedAHostNames[i] = false"
                     class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                     dsTooltipColor="black"
                     [dsTooltip]="'<b>' + ((isCopiedAHostNames[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                  </a>
                </p>
                <p [ngClass]="{'ds-lazy-load': loading}">
                  <input type="text" class="form-control" [(ngModel)]="record.value" #inputNameServer>
                  <a [ngxClipboard]="inputNameServer" (cbOnSuccess)="copiedNameServer(i)" (click)="isCopiedCodes[i] = true"
                     (onTooltipHide)="isCopiedCodes[i] = false"
                     class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                     dsTooltipColor="black"
                     [dsTooltip]="'<b>' + ((isCopiedCodes[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="ds-notification-warning ds-notification-warning-dns" *ngIf="cdnIsLive || showVerify">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p>
          <span [innerHTML]="'text_dnsNotification' | dbText"></span>
        </p>
      </div>
    </div>
  </div>


  <div class="text-right mt30">
    <a class="ds-btn-blue ds-btn-l" (click)="confirm()">
      <span>{{!showVerify && !cdnIsLive ? "Next" : "Done, I've Updated DNS"}}</span>
    </a>
  </div>

</div>
